export function isNullOrWhitespace(str) {
    return str === null || str.trim() === '';
  }
export function wait(ms) {return new Promise(resolve =>  setTimeout( resolve, ms));}

export function RenderRoleTag(roleName){
  let lstResult = [];
  roleName?.map((item, value) => {
    switch (item) {
      case 2:
        lstResult.push(
          <div key={value} className={`gx-badge gx-text-white gx-bg-green`}>
            عضویت معمولی
          </div>
        );
        break;
      case 3:
        lstResult.push(
          <div key={value} className={`gx-badge gx-text-white gx-bg-yellow`}>
             نماینده
          </div>
        );
        break;
      case 4:
        lstResult.push(
          <div key={value} className={`gx-badge gx-text-white gx-bg-cyan`}>
            پیشخوان
          </div>
        );
        break;
      case 5:
        lstResult.push(
          <div key={value} className={`gx-badge gx-text-white gx-bg-cyan`}>
            مدیر
          </div>
        );
        break;
      /* case 6:
        lstResult.push(
          <div key={value} className={`gx-badge gx-text-white gx-bg-purple`}>
            پشتیبان
          </div>
        );
        break; */
    }
  });
  return lstResult;
};